module.exports = __webpack_public_path__ + "img/aboutus.fa81045b.png";